import { useFetch } from 'hooks';
import { Constants } from 'global';
import { BranchChangeOwnership } from 'types/interfaces/branch/branchChangeOwnership';

interface UpdateBranchDetailsFunctions {
  sendChangeOwnershipFormAsync: (
    payload: BranchChangeOwnership
  ) => Promise<void>;
}

export const useUpdateBranchDetailsFunctions =
  (): UpdateBranchDetailsFunctions => {
    const { post } = useFetch();

    async function sendChangeOwnershipFormAsync(
      payload: BranchChangeOwnership
    ): Promise<void> {
      const res = await post('/form/send-change-ownership-form', payload);

      if (res.status !== 200) {
        let errorMessage: string;

        switch (res.status) {
          case 409: // Missing ExternalId
            errorMessage =
              'Branch is mis-configured. Contact our support team to update';
            break;
          case 422: // Disabled or VirtualBranch
            errorMessage = `Your current branch setup is a little different,
                            Our team can help you set up a new branch, Please email us
                            at ${Constants.emails.support}`;
            break;
          default:
            errorMessage = 'Something went wrong when generating the form';
        }

        throw new Error(errorMessage);
      }
    }

    return {
      sendChangeOwnershipFormAsync: sendChangeOwnershipFormAsync,
    };
  };

export default useUpdateBranchDetailsFunctions;
